import { AccesSearchResult } from './acces-search-result';

export class AccesPilotageEcoOrder {
	
	accesOuvrageIds: string[] = [];
	
}